import types from './types';

const INITIAL_STATE = {
  isPosting: false,
  isFetching: false,

  result: [],
};

const authHistoryReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.POST_AUTH_HISTORY_REQUEST:
        return {
            ...state,
            result: [],
            isPosting: true,
        };

    case types.POST_AUTH_HISTORY_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isPosting: false,
        };

    case types.POST_AUTH_HISTORY_FAILURE:
        return {
            ...state,
            result: [],
            isPosting: false,
        };

    case types.GET_SPEC_CODE_LIST_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_SPEC_CODE_LIST_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_SPEC_CODE_LIST_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    default:
      return state;
  }
};

export default authHistoryReducer;
